import React, { useState, useContext } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import OverviewTab from "./OverviewTab";
import ViolationsTab from "./ViolationsTab";
import WorkOrdersTab from "./WorkOrdersTab";
import ArchitecturalRequestsTab from "./ArchitecturalRequestsTab";
import Billing from "./Billing";
import { PermissionsContext } from "../../utils/PermissionsContext";

const ReportsPage = () => {
  // Support both array and function-style context
  const permissionsCtx = useContext(PermissionsContext);

  // If permissionsCtx is an array, convert it to a checker function
  const hasPermission = typeof permissionsCtx === "function"
    ? permissionsCtx
    : (perm) => Array.isArray(permissionsCtx) && permissionsCtx.includes(perm);

  const tabConfig = [
    { label: "Overview", component: <OverviewTab />, permission: null },
    { label: "Violations", component: <ViolationsTab />, permission: "view_violations" },
    { label: "Work Orders", component: <WorkOrdersTab />, permission: "view_work_orders" },
    { label: "Architectural Requests", component: <ArchitecturalRequestsTab />, permission: "view_architectural_requests" },
    { label: "Billing", component: <Billing />, permission: "view_work_orders" }, 
  ];

  const visibleTabs = tabConfig.filter(
    ({ permission }) => !permission || hasPermission(permission)
  );

  const [currentTab, setCurrentTab] = useState(0);
  const handleChange = (event, newValue) => setCurrentTab(newValue);

  if (visibleTabs.length === 0) {
    return (
      <Box sx={{ padding: 3 }}>
        <Typography>You do not have permission to view any reports.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: 3 }}>
      <Tabs
        value={currentTab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="Reports Tabs"
        sx={{ marginBottom: 3 }}
      >
        {visibleTabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>

      <Box>
        {visibleTabs[currentTab]?.component}
      </Box>
    </Box>
  );
};

export default ReportsPage;
